import { render } from "./PackagesView.vue?vue&type=template&id=526b7c1e&scoped=true"
import script from "./PackagesView.vue?vue&type=script&lang=js"
export * from "./PackagesView.vue?vue&type=script&lang=js"

import "./PackagesView.vue?vue&type=style&index=0&id=526b7c1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526b7c1e"]])

export default __exports__